<template>
  <FilterHeader
    id="filter-cat"
    class="search-filter"
    :data-cy="dataCy"
    :title="filterTitle"    
    :selections="selections"
    :filterDisabled="filterDisabled"
    :hideSave="true"   
    :hideFooterBtn="true" 
    @submitFilter="submitFilter"
    @cleanSelected="cleanSelected"
  >
    <ul class="pa-0 mr-5 list-style-none rtl">
      <li v-for="(item, index) in filterOptionsByUrl" :key="index" class="category-item">
        <nuxt-link
          :to="item.Link"
          :dataCy="`cy-button-category-filter`"
          class="category-filter-link mt-0"
          :title="item.NameInHebrew"
        >{{item.NameInHebrew}}</nuxt-link>
      </li>
    </ul>
  </FilterHeader>
</template>


<script>
import FilterBaseVue from './mixins/FilterBase.vue';
import SearchParams from '@/lib/enums/SearchParams';

export default {
  mixins: [FilterBaseVue],

  computed: {
    getCurrenBasetUrl() {
      return this.$route.fullPath.includes(SearchParams.Constants.DefaultBaseUrlNoCv) ? 
      SearchParams.Constants.DefaultBaseUrlNoCv : SearchParams.Constants.DefaultBaseUrl;
    },
    filterOptionsByUrl() {
      for(const item of Object.entries(this.filterOptions)) {
        item[1].Link = item[1].Link.replace(SearchParams.Constants.DefaultBaseUrl, this.getCurrenBasetUrl);
      }
      return this.filterOptions;
    }
  }
}
</script>

<style scoped>
.category-item {
  text-align: right;
}
</style>
